import React from 'react';
import LegalDocumentLayout from './LegalDocumentLayout';

const PrivacyPolicy = () => {
  return (
    <LegalDocumentLayout title="Privacy Policy">
      <p className="legal-document__updated">Last updated: March 2026</p>

      <p>
        This Privacy Policy describes how Back to School Forms (“we,” “us,” or “our”) handles information when you
        use our enrollment and school registration application on behalf of yourself or your student. Your school
        district operates its own registration program through this platform; the district is responsible for its
        policies and practices as they relate to student records and education law.
      </p>

      <h2>Information we collect</h2>
      <p>We may collect and process information that you or your district provide when using the service, including:</p>
      <ul>
        <li>Account information (such as name, email address, and login credentials)</li>
        <li>Information submitted on enrollment and related forms (such as student demographics, contact details, health or emergency information, and documents where applicable)</li>
        <li>Technical information needed to operate the service (such as IP address, browser type, and general usage logs)</li>
        <li>
          Electronic signature records, when you sign a form — the signature you draw, the date and time it was
          captured, and the IP address and browser/device type of the device used to sign — retained as evidence of
          who completed the form. We do not collect your location when you sign.
        </li>
      </ul>

      <h2>How we use information</h2>
      <p>We use this information to:</p>
      <ul>
        <li>Provide, maintain, and secure the application</li>
        <li>Process and transmit registration and form data to your school district as part of the enrollment workflow</li>
        <li>Communicate with you about your account or the service when necessary</li>
        <li>Maintain electronic signature records and an audit trail of form submissions and changes</li>
        <li>Comply with applicable law and respond to lawful requests</li>
      </ul>

      <h2>We do not sell your personal information</h2>
      <p>
        We do not sell your personal information or your student’s personal information to third parties. We do not
        use your data for third-party behavioral advertising.
      </p>

      <h2>Sharing of information</h2>
      <p>
        We may share information with service providers who assist us in hosting, securing, or operating the
        application, subject to appropriate safeguards. We may disclose information when required by law or to protect
        the rights, safety, and integrity of users, the service, or the public. Form and registration data you submit
        is available to your school district for legitimate educational and administrative purposes.
      </p>

      <h2>Data retention</h2>
      <p>
        We retain information for as long as necessary to operate the application, support school registration and
        enrollment for your district, meet legal or contractual obligations, and resolve disputes. Retention periods may
        vary depending on district requirements and applicable law.
      </p>

      <h2>Your choices and deletion requests</h2>
      <p>
        To request access to, correction of, or deletion of personal information associated with your use of the
        service, please contact the administrator of your school district. The district is best positioned to verify
        your identity, evaluate requests in light of education and public records requirements, and coordinate any
        changes with us where appropriate.
      </p>

      <h2>Security</h2>
      <p>
        We implement reasonable technical and organizational measures designed to protect information against
        unauthorized access, loss, or misuse. No method of transmission over the Internet or electronic storage is
        completely secure.
      </p>

      <h2>Children’s and students’ information</h2>
      <p>
        The service is used in connection with K–12 enrollment. Information about students is typically provided by
        parents, guardians, or district staff. If you believe we have collected student information improperly, please
        contact your district administrator.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will post the revised policy on this page and update
        the “Last updated” date when we do.
      </p>

      <h2>Contact</h2>
      <p>
        For questions about this Privacy Policy, you may contact your school district’s administrator. For technical
        or platform questions, use the contact method your district provides for this service.
      </p>
    </LegalDocumentLayout>
  );
};

export default PrivacyPolicy;
